import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import LogoutLink from './LogoutLink';
import Avatar from 'src/assets/images/avatar.jpg';

class Menu extends Component {
    render() {
        const { name } = this.props;
        return (
            <ul className="navbar-nav align-items-center d-none d-md-flex">
                <li className="nav-item dropdown">
                    <a className="nav-link pr-0" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <div className="media align-items-center">
                            <span className="avatar avatar-sm rounded-circle">
                                <img alt="Foto" src="https://cdn3.iconfinder.com/data/icons/web-design-and-development-2-6/512/87-512.png" />
                            </span>
                            <div className="media-body ml-2 d-none d-lg-block">
                                <span className="mb-0 text-sm font-weight-bold">{name}</span>
                                <i className="fas fa-caret-down ml-2"></i>
                            </div>
                        </div>
                    </a>
                    <div className="dropdown-menu dropdown-menu-arrow dropdown-menu-right">
                        <Link to="/conta" className="dropdown-item">
                            <i className="fas fa-user" />
                            <span>Conta</span>
                        </Link>
                        <Link to="/alterar-senha" className="dropdown-item">
                            <i className="fas fa-lock" />
                            <span>Alterar Senha</span>
                        </Link>
                        <div className="dropdown-divider" />
                        <LogoutLink />
                    </div>
                </li>
            </ul>
        );
    }
}


const mapStateToProps = (state) => ({
    name: state.user.name
});

const mapDispatchToProps = ({
//   logout
});

export default connect(mapStateToProps, mapDispatchToProps)(Menu);



// WEBPACK FOOTER //
// ./src/components/Layout/Topbar/Menu.js